export type PortfolioPageProps = {
    portfolioId: string;
  };
  
  export const PortfolioPage = ({ portfolioId }: PortfolioPageProps) => {
    return <div>Accounts Page</div>;
  };